import * as Servlet from '../../common/servlet'
import * as Common from '../../common/common'
import axios from "axios";
import $ from 'jquery';
window.jQuery = $
window.$ = $

/***************************************
************** 시작 ********************
****************************************/
window.addEventListener('DOMContentLoaded', (event) => {
	fileData();
})


function fileData() {
	document.querySelectorAll(".vfile ul li").forEach((info, i) => {
		info.addEventListener("click", function() {
			downloadBlob(this.id);
		})
	})
}

function downloadBlob(id) {
	let flseq = id;
	let seq = document.getElementById("seq").value;

	$.ajax({
		url: "/page/notice/fileDownload",
		type: 'POST',
		dataType: "json",
		data: {
			flseq: flseq,
			seq: seq
		},
		success: function(data) {
			if (data && data.fl) {
				const blobData = data.fl;
				const blobArray = atob(blobData); // base64 문자열 디코딩
				
				// 디코딩된 문자열 buffer에 넣기
				const arraybuffer  = new ArrayBuffer(blobArray.length);
				const view = new Uint8Array(arraybuffer);
				for(let i = 0; i < blobArray.length; i++) {
					view[i] = blobArray.charCodeAt(i); // UTF-16 코드를 나타내는 0부터 65535 사이의 정수를 반환
				}
				
				// 이진데이터로 만들었기때문에 해당 컨텐트 타입으로 설정
				const contentType = 'application.octet-stream';
				
				// blob 생성
				const blob = new Blob([arraybuffer], {type:contentType})
				
				// 생성된 blob 다운로드
				const downloadLink = document.createElement('a'); // 다운로드를 위한 a 태그 생성
				downloadLink.href = URL.createObjectURL(blob);
				
				// 다운로드 파일명 설정
				const fileName = data.rlfnm + "." + data.flext;
				downloadLink.download = fileName;
				
				// 다운로드
				document.body.appendChild(downloadLink);
				downloadLink.click();
				document.body.removeChild(downloadLink);
			} else {
				alert("No Blob data received.");
			}
		},
		error: function() {
			alert("error");
		}
	})
}

































